export const Types = {
    SET_BREADCRUMB: "SET_BREADCRUMB",
}